// extracted by mini-css-extract-plugin
export var arrows = "_6i-5";
export var decrementer = "_6i-9";
export var disabled = "_6i-3";
export var error = "_6i-1";
export var hiddenText = "_6i-a";
export var incrementer = "_6i-8";
export var input = "_6i-7";
export var inputWrapper = "_6i-0";
export var leadingIcon = "_6i-b";
export var readonly = "_6i-2";
export var regular = "_6i-6";
export var small = "_6i-4";